<template>
  <section class="btmNavi">
    <router-link to="/demo">
      <img
        v-if="!isHome"
        src="@/assets/img/ico/bottomNavigation/bottom_icon_home.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/img/ico/bottomNavigation/bottom_icon_home_t.svg"
        alt=""
      />
      <p :class="{ on: isHome }">{{ $t('mainpage.home') }}</p>
    </router-link>
    <router-link to="/Store">
      <img
        v-if="!isStore"
        src="@/assets/img/ico/bottomNavigation/bottom_icon_shop.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/img/ico/bottomNavigation/bottom_icon_shop_t.svg"
        alt=""
      />
      <p :class="{ on: isStore }">{{ $t('mainpage.category') }}</p>
    </router-link>
    <button @click="navRouter('Basket')" class="btn">
      <img
        v-if="!isBasket"
        src="@/assets/img/ico/bottomNavigation/bottom_icon_pick.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/img/ico/bottomNavigation/bottom_icon_pick_t.svg"
        alt=""
      />
      <p :class="{ on: isBasket }">{{ $t('mainpage.pick') }}</p>
    </button>
    <router-link to="/Mypage">
      <img
        v-if="!isMypage"
        src="@/assets/img/ico/bottomNavigation/bottom_icon_my.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/img/ico/bottomNavigation/bottom_icon_my_t.svg"
        alt=""
      />
      <p :class="{ on: isMypage }">{{ $t('mainpage.mypage') }}</p>
    </router-link>
    <button @click="navRouter('ViewLog')">
      <div
        class="viewBox"
        :style="{
          backgroundImage: viewPrdt
            ? `url('${viewPrdt.squareImageUrl || viewPrdt.bigImageUrl}')`
            : ''
        }"
      />
      <p :class="{ on: isViewLog }">{{ $t('mainpage.recentView') }}</p>
    </button>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { getRecentViewList } from '@/api/index'
export default {
  name: 'BottomNavigation',
  data() {
    return {
      isHome: false,
      isStore: false,
      isBasket: false,
      isMypage: false,
      isViewLog: false,
      viewPrdt: {}
    }
  },
  computed: {
    ...mapState(['isLogin'])
  },
  watch: {
    $route: {
      handler(n) {
        this.isHome = false
        this.isStore = false
        this.isBasket = false
        this.isMypage = false
        this.isViewLog = false
        if (n.name === 'Home') {
          this.isHome = true
        }
        if (n.name === 'Store') {
          this.isStore = true
        }
        if (n.name === 'Basket') {
          this.isBasket = true
        }
        if (n.name === 'MyPage') {
          this.isMypage = true
          this.syncViewPrdt()
        }
        if (n.name === 'ViewLog') {
          this.isViewLog = true
        }
        if (n.name === 'ProductDetail') {
          this.syncViewPrdt()
        }
      }
    }
  },
  mounted() {
    if (this.$route.name === 'Home') {
      this.isHome = true
    }
    if (this.$route.name === 'Store') {
      this.isStore = true
    }
    if (this.$route.name === 'Basket') {
      this.isBasket = true
    }
    if (this.$route.name === 'MyPage') {
      this.isMypage = true
    }
    if (this.$route.name === 'ViewLog') {
      this.isViewLog = true
    }
    this.syncViewPrdt()
  },
  methods: {
    navRouter(name) {
      this.$router.push({ name: name })
    },
    syncViewPrdt() {
      setTimeout(async () => {
        if (sessionStorage.getItem('botNavPrdt')) {
          this.viewPrdt = this.$ss.get('botNavPrdt')
        }
        if (this.isLogin) {
          // 회원인 경우
          let str = `?startIndex=0&rowCount=1`
          const res = await getRecentViewList(
            sessionStorage.getItem('accessToken'),
            str
          )
          console.log('최근본상품: ', res)
          if (
            res.data.jsonData.resultCode === '0001' &&
            res.data.jsonData.views.length > 0
          ) {
            this.viewPrdt = res.data.jsonData.views[0]
            this.$ss.set('botNavPrdt', res.data.jsonData.views[0])
          }
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.btmNavi {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 105;
  width: 100%;
  height: 60px;
  background: #3b3b3b;
  border-top: 1px solid #a3a3a3;
  font-size: 0;
  a,
  button {
    display: inline-block;
    width: 20%;
    height: 100%;
    text-align: center;
    vertical-align: top;
    img {
      margin-top: 8px;
    }
    p {
      font-size: 10px;
      color: #a3a3a3;
      &.on {
        color: #ff4f70;
      }
    }
    .viewBox {
      display: block;
      width: 28px;
      height: 28px;
      margin: 0 auto 1px auto;
      border-radius: 50%;
      background-color: #c4c4c4;
      border: 1px solid #c4c4c4;
      box-sizing: border-box;
      background-position: 50% 50%;
      background-size: cover;
    }
  }
  button.btn {
    border: none;
    padding: 0;
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>